import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, User, ShoppingBag, Info, FileText, Shield, Cookie, HelpCircle, Home, Crown } from 'lucide-react';
import { useOrderCount } from '../hooks/useOrderCount';
import { useAuth } from '../contexts/AuthContext';

const MobileMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const orderCount = useOrderCount();
  const { user } = useAuth();

  const toggleMenu = () => setIsOpen(!isOpen);
 
  const menuItems = [
    { icon: Home, label: 'Accueil', path: '/' },
    { icon: User, label: 'Mon Profil', path: '/client-profile' },
    {  
      icon: ShoppingBag, 
      label: 'Mes Commandes', 
      path: '/client-orders',
      badge: orderCount > 0 ? orderCount : undefined
    },
    { icon: Info, label: 'À Propos', path: '/about' },
    { icon: HelpCircle, label: 'FAQ', path: '/faq' },
    { icon: FileText, label: 'Conditions', path: '/terms' },
    { icon: Shield, label: 'Confidentialité', path: '/privacy' },
    { icon: Cookie, label: 'Cookies', path: '/cookies' },
  ];

  return (
    <>
      {/* Menu Button */}
      <button
        onClick={toggleMenu}
        className="p-2 text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-0 focus:border-0 active:outline-none"
        style={{ outline: 'none', border: 'none', boxShadow: 'none' }}
      >
        <Menu className="h-6 w-6" />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleMenu}
        />
      )}

      {/* Slide-out Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50 flex flex-col overflow-hidden ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        {/* Header - Fixed */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gradient-to-r from-primary-50 to-primary-100 flex-shrink-0">
          <div className="flex items-center">
            <div className="w-12 h-12 rounded-full overflow-hidden shadow-lg">
              <img
                src="/images/casap192.png"
                alt="CasaPresta"
                className="w-12 h-12 rounded-full object-cover"
              />
            </div>
            <div className="ml-3">
              <h2 className="text-lg font-script font-bold text-primary-900">CasaPresta</h2>
              <p className="text-sm text-primary-600">Services à domicile</p>
            </div>
          </div>
          <button
            onClick={toggleMenu}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-white/50 rounded-lg transition-colors focus:outline-none focus:ring-0"
            style={{ outline: 'none', border: 'none', boxShadow: 'none' }}
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto">
          {/* Back Button for Mobile */}
         

          {/* Menu Items */}
          <nav className="py-6">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={toggleMenu}
                  className="flex items-center justify-between px-6 py-4 transition-colors group text-gray-700 hover:bg-primary-50 hover:text-primary-600"
                >
                  <div className="flex items-center">
                    <Icon className="h-5 w-5 mr-4 group-hover:text-primary-600" />
                    <span className="font-medium">{item.label}</span>
                  </div>
                  {item.badge && (
                    <div className="bg-red-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center animate-pulse">
                      {item.badge > 99 ? '99+' : item.badge}
                    </div>
                  )}
                </Link>
              );
            })}
          </nav>

          {/* Quick Actions for Mobile - Removed */}
        </div>

        {/* Footer - Fixed */}
        <div className="p-6 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100 flex-shrink-0">
          <div className="text-center space-y-3">
            <div className="flex items-center justify-center space-x-1">
              <img
                src="/images/casap192.png"
                alt="CasaPresta"
                className="w-6 h-6 rounded-full object-cover"
              />
              <span className="text-sm font-script font-bold text-primary-600">CasaPresta</span>
            </div>
            <div className="space-y-1">
              <p className="text-xs text-gray-600 font-medium">
                📞 +225 05 44 86 77 55
              </p>
              <p className="text-xs text-gray-600 font-medium">
                📧 support@casapresta.online
              </p>
            </div>
            <div className="pt-2 border-t border-gray-300">
              <p className="text-xs text-gray-500">
                Version 1.0.0 • © 2025 CasaPresta
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Services à domicile de qualité
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;